import {getAppliedWhiteLabelThemeId} from "./whiteLabelThemes";

export const PRIVATESHARE_SUBSIDIARY_ID = 6;

export const resolveWhiteLabelSubsidiaryId = (subsidiaryId) => {
    if (getAppliedWhiteLabelThemeId() === "privateshare") {
        return PRIVATESHARE_SUBSIDIARY_ID;
    }

    return subsidiaryId;
};
